import { render } from "./BusinessSettingTable.vue?vue&type=template&id=99a02e64"
import script from "./BusinessSettingTable.vue?vue&type=script&lang=js"
export * from "./BusinessSettingTable.vue?vue&type=script&lang=js"
script.render = render

export default script